import revision from '../../../../public/build/img/rev-manifest.json'

export default function(name) {
    return '/build/img/' + revision[name]
}



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/sprite.js